import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "issueHoupiaoForm__content" }
const _hoisted_2 = { class: "routeTab" }
const _hoisted_3 = { class: "issueHoupiaoForm__overview" }
const _hoisted_4 = { class: "overview" }
const _hoisted_5 = { style: {"margin-right":"30px"} }
const _hoisted_6 = { class: "amount font-DIN" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "issueHoupiaoForm__formBlock" }
const _hoisted_9 = { class: "issueHoupiaoForm__squareRadio" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "电子普通发票", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "1天内开具", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "电子专用发票", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "预计7天内开具", -1)
const _hoisted_14 = { class: "issueHoupiaoForm__title" }
const _hoisted_15 = { class: "issueHoupiaoForm__formBlock" }
const _hoisted_16 = { class: "issueHoupiaoForm__formBlock" }
const _hoisted_17 = { class: "issueHoupiaoForm__formBlock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_address_editor_modal = _resolveComponent("address-editor-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "utils__pageContainer issueHoupiaoForm__wrap",
    title: "发票管理"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: { name: 'fapiao.issue_houpiao.form' } }, {
            default: _withCtx(() => [
              _createTextVNode("开发票")
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, { to: { name: 'fapiao.houpiao.list' } }, {
            default: _withCtx(() => [
              _createTextVNode("发票记录")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(" 订单数："),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.statistics.orderNum), 1)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" 开票总额："),
              _createElementVNode("span", {
                class: "amount font-DIN",
                innerHTML: _ctx.renderWithSub(_ctx.formatWithIntl(_ctx.statistics.totalAmount))
              }, null, 8, _hoisted_7),
              _createTextVNode(" 元 ")
            ])
          ])
        ]),
        _createVNode(_component_a_form, {
          ref: "editorFormRef",
          class: "issueHoupiaoForm__form",
          model: _ctx.formData,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_section, { title: "开票信息" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, {
                    label: "开票类型",
                    help: `发票金额超过${ _ctx.formData.invoiceType === '1' ? '1' : '10' }万时，系统会自动拆分成多张发票开具`,
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_9, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["recommend", { checked: _ctx.formData.invoiceType === '1' }])
                        }, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.invoiceType) = $event)),
                              type: "radio",
                              value: "1",
                              name: "fapiaoType"
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.invoiceType]
                            ]),
                            _hoisted_10,
                            _hoisted_11
                          ])
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass({ checked: _ctx.formData.invoiceType === '2' })
                        }, [
                          _createElementVNode("label", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.invoiceType) = $event)),
                              type: "radio",
                              value: "2",
                              name: "fapiaoType"
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.invoiceType]
                            ]),
                            _hoisted_12,
                            _hoisted_13
                          ])
                        ], 2)
                      ])
                    ]),
                    _: 1
                  }, 8, ["help"]),
                  _createVNode(_component_a_form_item, {
                    label: "发票抬头",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.orderParams.enterprise.enterpriseName), 1),
                        _createElementVNode("span", null, "纳税人识别号：" + _toDisplayString(_ctx.orderParams.enterprise.socialCreditCode), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "企业开户银行",
                    name: "accountBank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.accountBank,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.accountBank) = $event)),
                        placeholder: "请填写开户许可证上的银行",
                        maxlength: 50
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "企业银行账号",
                    name: "accountNo"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.accountNo,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.accountNo) = $event)),
                        maxlength: 30,
                        step: "1",
                        placeholder: "请填写开户许可证上的银行账号",
                        style: {"width":"100%"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "企业注册地址",
                    name: "registAddress"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.registAddress,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.registAddress) = $event)),
                        placeholder: "请填写营业执照上的注册地址",
                        maxlength: 100
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "企业固定电话",
                    name: "registTel"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formData.registTel,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.registTel) = $event)),
                        placeholder: "请填写企业固定电话ex(010-1000000)",
                        maxlength: 32
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "发票类型",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.invoiceTypeInfo.invoiceType), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "发票备注",
                    name: "remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: _ctx.formData.remark,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.remark) = $event)),
                        class: "issueHoupiaoForm__desc text-count-50",
                        rows: "5",
                        maxlength: 50,
                        "show-count": true,
                        placeholder: "请填写备注"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (_ctx.formData.invoiceType === '1')
              ? (_openBlock(), _createBlock(_component_app_section, {
                  key: 0,
                  title: "收件人信息"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "邮箱",
                        name: "invoiceReceiveEmail"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.invoiceReceiveEmail,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.invoiceReceiveEmail) = $event)),
                            placeholder: "请输入邮箱"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            loading: _ctx.submiting,
                            disabled: _ctx.submiting,
                            onClick: _ctx.onSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("开发票")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formData.invoiceType === '2')
              ? (_openBlock(), _createBlock(_component_app_section, {
                  key: 1,
                  title: "收件人信息"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_form_item, {
                          label: "邮箱",
                          name: "invoiceReceiveEmail"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formData.invoiceReceiveEmail,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.invoiceReceiveEmail) = $event)),
                              placeholder: "请输入邮箱"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            loading: _ctx.submiting,
                            disabled: _ctx.submiting,
                            onClick: _ctx.onSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("开发票")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])
      ]),
      _createVNode(_component_address_editor_modal, {
        ref: "addressEditorRef",
        onComplete: _ctx.loadAddressList
      }, null, 8, ["onComplete"])
    ]),
    _: 1
  }))
}